import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import BrandLogo from '../components/BrandLogo';

// Icons
const ProjectIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

const LearnIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2 3H8C9.06087 3 10.0783 3.42143 10.8284 4.17157C11.5786 4.92172 12 5.93913 12 7V21C12 20.4696 11.7893 19.9609 11.4142 19.5858C11.0391 19.2107 10.5304 19 10 19H2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M22 3H16C14.9391 3 13.9217 3.42143 13.1716 4.17157C12.4214 4.92172 12 5.93913 12 7V21C12 20.4696 12.2107 19.9609 12.5858 19.5858C12.9609 19.2107 13.4696 19 14 19H22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

const ContactIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z" fill="currentColor"/>
    </svg>
);

const TelegramIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM16.64 8.8C16.49 10.38 15.84 14.24 15.51 15.99C15.37 16.73 15.1 16.98 14.86 17C14.33 17.05 13.93 16.65 13.42 16.31C12.62 15.79 12.17 15.46 11.39 14.95C10.49 14.35 11.07 14.02 11.58 13.49C11.71 13.35 13.99 11.28 14.03 11.09C14.04 11.07 14.04 10.98 13.98 10.93C13.92 10.87 13.84 10.89 13.77 10.91C12.87 11.48 11.13 12.66 10.77 12.9C10.51 13.06 10.15 13.14 9.87 13.13C9.25 13.11 8.05 12.77 7.16 12.48C6.39 12.23 5.96 12.1 6.01 11.67C6.04 11.45 6.34 11.22 6.95 10.97C9.8 9.77 11.7 8.98 12.66 8.58C14.58 7.78 14.98 7.64 15.24 7.64C15.3 7.64 15.44 7.65 15.53 7.73C15.62 7.8 15.64 7.9 15.65 7.96C15.65 8.02 15.66 8.23 16.64 8.8Z" fill="currentColor"/>
    </svg>
);

const NAV_ITEMS = [
    {
        name: 'W3LO Project',
        description: 'Project Intro & Whitepaper',
        url: '/project-intro',
        Icon: ProjectIcon,
        isInternal: true
    },
    {
        name: 'Learn About',
        description: 'Training & Guides',
        url: '/learn',
        Icon: LearnIcon,
        isInternal: true
    },
    {
        name: 'Contact Us',
        description: 'Support & Inquiries',
        url: '/contact',
        Icon: ContactIcon,
        isInternal: true
    }
];

export default function ContactUs() {
    const navigate = useNavigate();
    const location = useLocation();

    // Scroll to top on mount
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    return (
        <div className="landing-page" style={{ background: 'var(--bg-dark)', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            {/* Top Navigation Bar */}
            <nav className="top-navbar">
                <div className="navbar-container">
                    {/* Logo */}
                    <div className="navbar-logo" onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
                        <BrandLogo size={36} />
                        <div className="navbar-logo-text">
                            <span>
                                web3lab
                                <span style={{ fontSize: '0.45em', opacity: 0.8, marginLeft: '2px', position: 'relative', top: '-2px' }}>.online</span>
                            </span>
                            <span className="navbar-logo-subtitle">training</span>
                        </div>
                    </div>

                    {/* Navigation Items */}
                    <div className="navbar-items">
                        {NAV_ITEMS.map((item) => (
                            <a
                                key={item.name}
                                href={item.url}
                                className={`navbar-item ${location.pathname === item.url ? 'active' : ''}`}
                                onClick={(e) => {
                                    e.preventDefault();
                                    navigate(item.url);
                                }}
                                style={{
                                    background: location.pathname === item.url ? 'rgba(255, 255, 255, 0.05)' : 'transparent'
                                }}
                            >
                                <span className="navbar-item-icon">
                                    <item.Icon />
                                </span>
                                <div className="navbar-item-content">
                                    <span className="navbar-item-name">{item.name}</span>
                                    <span className="navbar-item-desc">{item.description}</span>
                                </div>
                            </a>
                        ))}
                    </div>
                </div>
            </nav>

            {/* Main Content */}
            <div className="main-content" style={{ maxWidth: '1000px', margin: '0 auto', padding: '40px 20px', width: '100%' }}>
                <h1 style={{ fontSize: '2.5rem', marginBottom: '10px', color: 'var(--text-primary)', textAlign: 'center' }}>Contact Us</h1>
                <p style={{ textAlign: 'center', color: 'var(--text-secondary)', marginBottom: '40px', fontSize: '1.1rem' }}>
                    We're here to help! Choose the support channel that best fits your needs.
                </p>

                {/* Live Support Channels (Crisp & Telegram) */}
                <div style={{ background: 'linear-gradient(135deg, rgba(76, 175, 80, 0.1) 0%, rgba(33, 150, 243, 0.1) 100%)', padding: '30px', borderRadius: '16px', border: '1px solid rgba(255, 255, 255, 0.1)', marginBottom: '40px', textAlign: 'center' }}>
                    <h2 style={{ fontSize: '1.8rem', color: 'var(--text-primary)', marginBottom: '15px' }}>Live Support Channels</h2>
                    <p style={{ color: 'var(--text-secondary)', fontSize: '1.1rem', marginBottom: '25px', maxWidth: '700px', margin: '0 auto 25px auto' }}>
                        Need immediate assistance? Connect with our support team instantly via our website widget or Telegram.
                    </p>
                    
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', flexWrap: 'wrap' }}>
                        {/* Crisp Button */}
                        <button 
                            onClick={() => (window as any).$crisp?.push(["do", "chat:open"])}
                            style={{
                                background: '#4CAF50',
                                color: 'white',
                                border: 'none',
                                padding: '12px 30px',
                                borderRadius: '8px',
                                fontSize: '1rem',
                                fontWeight: '600',
                                cursor: 'pointer',
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '10px',
                                transition: 'transform 0.2s, background 0.2s',
                                boxShadow: '0 4px 14px rgba(76, 175, 80, 0.3)'
                            }}
                            onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                            onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                        >
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H6L4 18V4H20V16Z" fill="currentColor"/>
                            </svg>
                            Live Chat
                        </button>

                        {/* Telegram Button */}
                        <a 
                            href="https://t.me/web3lab_support" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            style={{
                                background: '#0088cc',
                                color: 'white',
                                textDecoration: 'none',
                                padding: '12px 30px',
                                borderRadius: '8px',
                                fontSize: '1rem',
                                fontWeight: '600',
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '10px',
                                transition: 'transform 0.2s, background 0.2s',
                                boxShadow: '0 4px 14px rgba(0, 136, 204, 0.3)'
                            }}
                            onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                            onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                        >
                            <TelegramIcon />
                            Telegram Support
                        </a>
                    </div>
                </div>

                {/* Support Sections */}
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '30px', marginBottom: '40px' }}>
                    {/* General Support */}
                    <div style={{ background: 'var(--bg-card)', padding: '30px', borderRadius: '16px', border: '1px solid var(--border-color)' }}>
                        <h2 style={{ fontSize: '1.5rem', marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '10px', color: 'var(--accent-primary)' }}>
                            <span style={{ fontSize: '24px' }}>🎧</span> General Support
                        </h2>
                        <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 20px 0', color: 'var(--text-secondary)' }}>
                            <li style={{ marginBottom: '10px', display: 'flex', gap: '10px' }}>
                                <span style={{ color: 'var(--accent-primary)' }}>•</span> General inquiries
                            </li>
                            <li style={{ marginBottom: '10px', display: 'flex', gap: '10px' }}>
                                <span style={{ color: 'var(--accent-primary)' }}>•</span> Bug reports
                            </li>
                            <li style={{ marginBottom: '10px', display: 'flex', gap: '10px' }}>
                                <span style={{ color: 'var(--accent-primary)' }}>•</span> Feature suggestions
                            </li>
                            <li style={{ marginBottom: '10px', display: 'flex', gap: '10px' }}>
                                <span style={{ color: 'var(--accent-primary)' }}>•</span> Account issues
                            </li>
                        </ul>
                        <div style={{ marginTop: 'auto', paddingTop: '20px', borderTop: '1px solid var(--border-color)' }}>
                            <p style={{ margin: '0 0 5px 0', color: 'var(--text-primary)', fontWeight: '600' }}>Email:</p>
                            <a href="mailto:support@web3lab.online" style={{ color: 'var(--accent-primary)', textDecoration: 'none' }}>support@web3lab.online</a>
                            <p style={{ margin: '15px 0 5px 0', color: 'var(--text-primary)', fontWeight: '600' }}>Response Time:</p>
                            <p style={{ margin: 0, color: 'var(--text-secondary)' }}>1 hour</p>
                        </div>
                    </div>

                    {/* Developer Support */}
                    <div style={{ background: 'var(--bg-card)', padding: '30px', borderRadius: '16px', border: '1px solid var(--border-color)' }}>
                        <h2 style={{ fontSize: '1.5rem', marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '10px', color: '#E91E63' }}>
                            <span style={{ fontSize: '24px' }}>🛠️</span> Developer Support
                        </h2>
                        <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 20px 0', color: 'var(--text-secondary)' }}>
                            <li style={{ marginBottom: '10px', display: 'flex', gap: '10px' }}>
                                <span style={{ color: '#E91E63' }}>•</span> Technical integration
                            </li>
                            <li style={{ marginBottom: '10px', display: 'flex', gap: '10px' }}>
                                <span style={{ color: '#E91E63' }}>•</span> API documentation
                            </li>
                            <li style={{ marginBottom: '10px', display: 'flex', gap: '10px' }}>
                                <span style={{ color: '#E91E63' }}>•</span> Security vulnerabilities
                            </li>
                            <li style={{ marginBottom: '10px', display: 'flex', gap: '10px' }}>
                                <span style={{ color: '#E91E63' }}>•</span> Advanced configuration
                            </li>
                        </ul>
                        <div style={{ marginTop: 'auto', paddingTop: '20px', borderTop: '1px solid var(--border-color)' }}>
                            <p style={{ margin: '0 0 5px 0', color: 'var(--text-primary)', fontWeight: '600' }}>Email:</p>
                            <a href="mailto:dev@web3lab.online" style={{ color: '#E91E63', textDecoration: 'none' }}>dev@web3lab.online</a>
                            <p style={{ margin: '15px 0 5px 0', color: 'var(--text-primary)', fontWeight: '600' }}>Response Time:</p>
                            <p style={{ margin: 0, color: 'var(--text-secondary)' }}>Within 24 hours</p>
                        </div>
                    </div>
                </div>

                {/* Additional Info */}
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '30px' }}>
                    {/* Working Hours */}
                    <div style={{ background: 'rgba(255, 255, 255, 0.03)', padding: '24px', borderRadius: '12px' }}>
                        <h3 style={{ fontSize: '1.2rem', marginBottom: '15px', color: 'var(--text-primary)' }}>Working Hours</h3>
                        <p style={{ color: 'var(--text-secondary)', lineHeight: '1.6' }}>
                            Monday - Friday<br/>
                            9:00 AM - 6:00 PM (Dubai Time)<br/>
                            <span style={{ fontSize: '0.9rem', opacity: 0.7 }}>GMT+4</span>
                        </p>
                    </div>

                    {/* Guidelines */}
                    <div style={{ background: 'rgba(255, 255, 255, 0.03)', padding: '24px', borderRadius: '12px' }}>
                        <h3 style={{ fontSize: '1.2rem', marginBottom: '15px', color: 'var(--text-primary)' }}>Request Guidelines</h3>
                        <p style={{ color: 'var(--text-secondary)', marginBottom: '10px' }}>To help us serve you better, please include:</p>
                        <ul style={{ listStyle: 'disc', paddingLeft: '20px', color: 'var(--text-secondary)', lineHeight: '1.6' }}>
                            <li>Clear subject line</li>
                            <li>Detailed description of the issue</li>
                            <li>Screenshots or error logs (if applicable)</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}
